import { responseError } from "../../lib/response-error";

export async function startReportGeneration(
  scope: "classroom" | "lesson",
  body: Record<string, string | number>,
  request: typeof fetch = fetch,
): Promise<void> {
  const response = await request(`/api/internal/admin/${scope}-reports/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw await responseError(response, "Failed to start generation");
}
